export const startupDataKey = 'startup:data';
export const practiceInvitationDataKey = 'practice-invitation:data';
export const globalFeaturesKey = 'globalFeatures';
export const forceTrackingUsingKey = 'FORCE_TRACKING_USING';
export const isTwoFaHardEnforcementKey = 'IS_TWO_FA_HARD_ENFORCEMENT';
